export function insertTextAtCursor(textarea, text, options = {}) {
  if (!textarea) return;

  const {
    ensureTrailingNewline = true
  } = options;

  const start = textarea.selectionStart ?? textarea.value.length;
  const end = textarea.selectionEnd ?? textarea.value.length;

  const value = textarea.value;
  const before = value.slice(0, start);
  const after = value.slice(end);

  let insertion = text;
  if (ensureTrailingNewline && !text.endsWith('\n')) {
    insertion += '\n';
  }

  const newValue = `${before}${insertion}${after}`;
  textarea.value = newValue;

  const caret = before.length + insertion.length;
  textarea.selectionStart = caret;
  textarea.selectionEnd = caret;
}

